import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { MOMENT_FORMAT, parse2Str } from '../../../common/utils/date';
import moment from 'moment';

export default function CustomizedTreeView({ treeData = [], isMobile }) {
  /**
   * Format time
   * @param {*} time 
   * @returns 
   */
  const formatTime = (time) => {
    if (time) {
      return parse2Str(new Date(parseInt(time)), MOMENT_FORMAT.YYYY_MM_DD_HH_MM_SS, true);
    }
    return time;
  }

  return (
    <Box sx={{ minHeight: 270, flexGrow: 1 }}>
      <ul class="tree">
        {
          treeData.map(company => {
            return (
              <li>
                <details open>
                  <summary>{company.label}</summary>
                  <ul>
                    {
                      company?.children && company.children.map(department => {
                        if(department.children[0].department){
                          return (
                            <li>
                              <details open>
                                <summary>{department.label}</summary>
                                <ul>
                                  {
                                    department?.children && department.children.map(location => {
                                      return (
                                        <li className='location'>
                                          <div className='email limit-text-1'>
                                            <div>{location?.displayName || ''}</div>
                                            <small style={{ color: 'blue' }}>{location?.updated_by || ''}</small>
                                          </div>
                                          <div className='last-location'>
                                            <div style={{textAlign: 'left'}}>{location?.floor_name || ''}</div>
                                            <div className='limit-text-2'>{location?.zone_code && `${location?.zone_name}`}</div>
                                            <small style={{textAlign: 'left'}}>{formatTime(location?.last_detected_time) || ''}</small>
                                          </div>
                                        </li>
                                      )
                                    })
                                  }
                                </ul>
                              </details>
                            </li>
                          )
                        }else{
                          return (
                            <>
                              {
                                department?.children && department.children.map(location => {
                                  return (
                                    <li className='location'>
                                      <div className='email limit-text-1'>
                                        <div style={{fontWeight: 'bold'}}>{location?.displayName || ''}</div>
                                        <small style={{ color: 'blue' }}>{location?.updated_by || ''}</small>
                                      </div>
                                      <div className='last-location'>
                                        <div style={{textAlign: 'left'}}>{location?.floor_name || ''}</div>
                                        <div className='limit-text-2'>{location?.zone_code && `${location?.zone_name}`}</div>
                                        <small style={{textAlign: 'left'}}>{formatTime(location?.last_detected_time) || ''}</small>
                                      </div>
                                    </li>
                                  )
                                })
                              }
                            </>
                          )
                        }
                      })
                    }
                  </ul>
                </details>
              </li>
            )
          })
        }

      </ul>
    </Box>
  );
}